import { Box, Tooltip } from "@mui/material";
import { useRequestPendingCount } from "../../../../../hook/query/useRequestPendingCount";

export default function RequestPendingBadge() {
  const { count, isError } = useRequestPendingCount();
  if (!isError && !count) return null;
  const label = isError
    ? "โหลดจำนวนคำร้องรอพิจารณาไม่สำเร็จ ระบบจะลองใหม่อัตโนมัติ"
    : `คำร้องรอพิจารณา ${count} เคส · ทุกเดือนและทุกแฟรนไชส์ที่คุณมีสิทธิ์ดู`;
  return (
    <Tooltip title={label}>
      <Box
        component="span"
        role="status"
        aria-label={label}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          minWidth: 24,
          height: 24,
          px: 0.75,
          mx: 1.5,
          borderRadius: 12,
          bgcolor: isError ? "warning.dark" : "error.main",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.8)",
          fontSize: 12,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {isError ? "!" : count! > 99 ? "99+" : count}
      </Box>
    </Tooltip>
  );
}
